const supportedLanguages = ['es', 'en'] as const;
type SupportedLanguages = typeof supportedLanguages[number];

export { supportedLanguages };
export type { SupportedLanguages };
